export default "__VITE_ASSET__Vq$ZHAY___"